// Who is signed in, across workspaces.
//
// Two bits of chrome ask for this — the workspace switcher and the account menu —
// and both mount on every screen, so the request is shared rather than made twice.
// It is a page-load cache, not a store: the answer only changes by signing in or
// out, and both of those navigate.

import { useEffect, useState } from 'react'

import { api, type Me } from './api'

let pending: Promise<Me> | null = null

/** One request per page load, shared by every caller. */
export function meOnce(): Promise<Me> {
  if (!pending) pending = api.me()
  return pending
}

export function useMe(): Me | null {
  const [me, setMe] = useState<Me | null>(null)
  useEffect(() => {
    let live = true
    meOnce()
      .then((m) => {
        if (live) setMe(m)
      })
      .catch(() => undefined)
    return () => {
      live = false
    }
  }, [])
  return me
}
